const upsertMeta = (attribute, key, content) => {
    let element = document.querySelector(`meta[${attribute}="${key}"]`);

    if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }

    element.setAttribute("content", content);
};

const replaceMetaGroup = (attribute, key, values) => {
    document.querySelectorAll(`meta[${attribute}="${key}"]`).forEach(element => element.remove());

    values.forEach(content => {
        const element = document.createElement("meta");
        element.setAttribute(attribute, key);
        element.setAttribute("content", content);
        document.head.appendChild(element);
    });
};

export const applyOpenGraphMeta = (meta) => {
    document.documentElement.lang = meta.htmlLang;
    document.title = meta.title;

    upsertMeta("name", "description", meta.description);

    upsertMeta("property", "og:title", meta.title);
    upsertMeta("property", "og:description", meta.description);
    upsertMeta("property", "og:type", meta.type);
    upsertMeta("property", "og:url", meta.url);
    upsertMeta("property", "og:site_name", meta.siteName);
    upsertMeta("property", "og:locale", meta.locale);
    upsertMeta("property", "og:image", meta.image);
    upsertMeta("property", "og:image:width", String(meta.imageWidth));
    upsertMeta("property", "og:image:height", String(meta.imageHeight));
    upsertMeta("property", "og:image:alt", meta.title);

    replaceMetaGroup("property", "og:locale:alternate", meta.localeAlternates);
};
